import { createContext } from 'react';
import type { FiasBridge } from './bridge';

/**
 * React context providing the bridge instance to all SDK hooks.
 */
export const FiasBridgeContext = createContext<FiasBridge | null>(null);
